"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFramesPerLambda = exports.getFramesPerLambda = void 0;
let framesPerLambda;
const getFramesPerLambda = () => {
    return framesPerLambda;
};
exports.getFramesPerLambda = getFramesPerLambda;
const setFramesPerLambda = (newFrames) => {
    framesPerLambda = newFrames;
};
exports.setFramesPerLambda = setFramesPerLambda;
